import React, { useEffect } from 'react';

const Upgrade: React.FC = () => {
  useEffect(() => {
    document.title = 'OfferFlow | Upgrade';
  }, []);

  return (
    <div>
    </div>
  );
};

export default Upgrade;
